import { Typography } from 'antd'

type Props = { light?: boolean }
export default function BrandLogo({ light = false }: Props) {
  return (
    <div className={`brand ${light ? 'brand--light' : ''}`} aria-label="TALENXA">
      <div className="brand__text">
        <Typography.Text className="brand__word">TALEN<span className="brand__x">X</span>A</Typography.Text>
        <Typography.Text className="brand__tag">ORGANIZATIONAL CONSULTING</Typography.Text>
      </div>
    </div>
  )
}
